import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-code",
  "use": "icon-code-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-code\">\n<path d=\"M2.47539 9.09062L5.45312 6.20605L5.45488 5.93359V4.69609L0.917969 9.09062L5.45488 13.4834V12.2459L5.45312 11.9734L2.47539 9.09062ZM15.2072 9.00625L12.2295 6.12344L12.2277 5.85098V4.61348L16.7646 9.00625L12.2277 13.4008V12.1615L12.2295 11.8891L15.2072 9.00625ZM8.125 15.0285H6.76094L9.55762 2.80469H10.9217L8.125 15.0285Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol